export const activityLog = {
  logs: [
    {
      triggerCode: 'Registration - User successfully registered',
      userId: 1237,
      user: {
        email: 'test@intellihealthcorp.com',
        fullName: 'Test OrgAdmin',
      },
      identityType: 'organization-admin',
      date: '04-30-2021 12:40:28 PM',
      message: 'Thank you for registering with Evolve!',
      dataChanged: null,
      createdBy: 12,
      updatedBy: 2,
    },
  ],
  total: 1,
  triggerCodes: ['User ID already exists', 'Password not strong enough', 'Invite sent'],
  usersList: [
    {
      email: 'test@intellihealthcorp.com',
      firstName: 'Test',
      lastName: 'OrgAdmin',
    },
  ],
};
export const activityLogDesc = {
  logs: [
    {
      triggerCode: 'Profile - View Patient List',
      userId: null,
      user: {
        email: '',
        fullName: 'Not defined',
      },
      identityType: null,
      date: '04-30-2021 12:36:06 PM',
      message: 'Provider viewed patient lists',
      dataChanged: {
        viewedPatientIds: [],
      },
      createdBy: null,
      updatedBy: null,
    },
  ],
  total: 1,
  triggerCodes: ['User ID already exists', 'Password not strong enough', 'Invite sent'],
  usersList: [],
};

export const activityLogAsc = {
  logs: [
    {
      triggerCode: 'Log in - Login was successful',
      userId: 10,
      user: {
        email: 'test@bmiq.com',
        fullName: 'IH Admin',
      },
      identityType: 'admin',
      date: '04-30-2021 01:14:24 PM',
      message: 'test@bmiq.com successfully logged in.',
      dataChanged: null,
      createdBy: 3,
      updatedBy: 4,
    },
  ],
  total: 1,
  triggerCodes: ['User ID already exists', 'Password not strong enough', 'Invite sent'],
  usersList: [],
};
